import CodeSpace from './CodeSpace';
import { CodeSpaceProps, CodeSpaceValueProps } from './types';

export type { CodeSpaceProps, CodeSpaceValueProps };
export default CodeSpace;
